import React, {
    useEffect,
    useState
} from "react";
import SingleSelectField from "../../common/searchconsultant/SingleSelectField";
import MultiSelectField from "../../common/profile/MultiSelectField";
import {
    useNavigate,
    Link,
    useParams
} from "react-router-dom";

import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import {
    postUserApp,
    getUserAppById,
    getAllRole,
    addRoleToUser,
    removeRoleFromUser,
} from "./ServiceUserApp";

export default function UpdateUserApp() {

    const { t } = useTranslation();

    const { id } = useParams();

    const navigate = useNavigate();

    // =========================================================
    // ETAT
    // =========================================================
const [roles, setRoles] = useState([]);

const [loadingRoles, setLoadingRoles] = useState(false);

    const [data, setData] = useState({
        id: "",
        userName: "",
        fullName: "",
        email: "",
        phoneNumber: "",
        webSide: "",

        falahOrProf: "",
        natureActivityType: "",

        enabled: true,
        roles: []
    });

    const [errorMessage, setErrorMessage] =
        useState({});

    const [loading, setLoading] =
        useState(true);

    const [saving, setSaving] =
        useState(false);

    // =========================================================
    // CHARGEMENT
    // =========================================================
const loadRoles = async () => {

    try {

        setLoadingRoles(true);

        const result = await getAllRole();

        setRoles(
            Array.isArray(result?.data)
                ? result.data
                : []
        );

    } catch (error) {

        console.error(
            "Erreur chargement rôles :",
            error
        );

        toast.error(
            t(
                "utilisateur.rolesLoadError",
                {
                    defaultValue:
                        "Impossible de charger les rôles."
                }
            ),
            {
                position: "bottom-right",
                autoClose: 3000
            }
        );

    } finally {

        setLoadingRoles(false);
    }
};

useEffect(() => {

    loadRoles();

}, []);



const onAddRole = async (role) => {

    if (!role) {
        return;
    }

    try {

        const roleName =
            role.name ||
            role.roleName;

        if (!roleName) {

            toast.error(
                t(
                    "utilisateur.roleInvalid",
                    {
                        defaultValue:
                            "Le rôle sélectionné est invalide."
                    }
                )
            );

            return;
        }

        await addRoleToUser(
            data.email,
            roleName
        );

        setData((prev) => ({

            ...prev,

            roles: [
                ...(prev.roles || []),
                role
            ]

        }));

        toast.success(
            t(
                "utilisateur.roleAddSuccess",
                {
                    defaultValue:
                        "Rôle ajouté avec succès."
                }
            ),
            {
                position: "bottom-right",
                autoClose: 2000
            }
        );

    } catch (error) {

        console.error(
            "Erreur ajout rôle :",
            error
        );

        toast.error(
            t(
                "utilisateur.roleAddError",
                {
                    defaultValue:
                        "Impossible d'ajouter le rôle."
                }
            ),
            {
                position: "bottom-right",
                autoClose: 3000
            }
        );
    }
};

const onRemoveRole = async (role) => {

    if (!role) {
        return;
    }

    try {

        const roleName =
            role.name ||
            role.roleName;

        if (!roleName) {
            return;
        }

        await removeRoleFromUser(
            data.email,
            roleName
        );

        setData((prev) => ({

            ...prev,

            roles: (prev.roles || []).filter(
                (item) => {

                    const itemName =
                        item.name ||
                        item.roleName;

                    return itemName !== roleName;
                }
            )

        }));

        toast.success(
            t(
                "utilisateur.roleRemoveSuccess",
                {
                    defaultValue:
                        "Rôle supprimé avec succès."
                }
            ),
            {
                position: "bottom-right",
                autoClose: 2000
            }
        );

    } catch (error) {

        console.error(
            "Erreur suppression rôle :",
            error
        );

        toast.error(
            t(
                "utilisateur.roleRemoveError",
                {
                    defaultValue:
                        "Impossible de supprimer le rôle."
                }
            ),
            {
                position: "bottom-right",
                autoClose: 3000
            }
        );
    }
};


    useEffect(() => {

        const loadUserApp = async () => {

            setLoading(true);

            try {

                const result =
                    await getUserAppById(id);

                setData(
                    result?.data ?? {}
                );

            } catch (error) {

                console.error(error);

                toast.error(
                    t("utilisateur.loadError"),
                    {
                        position:
                            "bottom-right",
                        autoClose: 3000,
                    }
                );

            } finally {

                setLoading(false);
            }
        };

        if (id) {
            loadUserApp();
        }

    }, [id, t]);

    // =========================================================
    // MODIFICATION CHAMP
    // =========================================================

  const onInputChange = (e) => {

    const {
        name,
        value,
        type,
        checked
    } = e.target;

    setData((prev) => ({
        ...prev,
        [name]:
            type === "checkbox"
                ? checked
                : value,
    }));
};

    // =========================================================
    // SUBMIT
    // =========================================================

    const onSubmit = async (e) => {

        e.preventDefault();

        setSaving(true);
        setErrorMessage({});

        try {

            await postUserApp(data);

            toast.success(
                t("utilisateur.editSuccess"),
                {
                    position:
                        "bottom-right",
                    autoClose: 2000,
                }
            );

            navigate("/listuserapp");

        } catch (error) {

            console.error(error);

            if (
                error?.response?.data?.errors
            ) {

                const errorArray =
                    error.response.data.errors;

                const errorObject = {};

                const formattedErrors =
                    errorArray.map(
                        (err, index) => {

                            const separatorIndex =
                                err.indexOf(":");

                            let message = err;

                            if (
                                separatorIndex !== -1
                            ) {

                                const field =
                                    err.substring(
                                        0,
                                        separatorIndex
                                    ).trim();

                                message =
                                    err.substring(
                                        separatorIndex + 1
                                    ).trim();

                                errorObject[field] =
                                    message;
                            }

                            return (
                                <li
                                    key={index}
                                    className="list-group-item"
                                >
                                    {message}
                                </li>
                            );
                        }
                    );

                setErrorMessage(
                    errorObject
                );

                toast.error(
                    <div>

                        <h6>
                            {t(
                                "common.validationErrors",
                                {
                                    defaultValue:
                                        "Erreurs de validation.",
                                }
                            )}
                        </h6>

                        <ul className="list-group list-group-flush">

                            {formattedErrors}

                        </ul>

                    </div>,
                    {
                        position:
                            "bottom-right",
                        autoClose: 4000,
                    }
                );

            } else {

                toast.error(
                    t("utilisateur.updateError"),
                    {
                        position:
                            "bottom-right",
                        autoClose: 3000,
                    }
                );
            }

        } finally {

            setSaving(false);
        }
    };

    // =========================================================
    // CHARGEMENT
    // =========================================================

    if (loading) {

        return (

            <div
                className="div-width text-center"
                style={{
                    marginTop: "8rem"
                }}
            >

                <div
                    className="spinner-border text-primary"
                    role="status"
                >

                    <span className="visually-hidden">
                        {t("common.loading")}
                    </span>

                </div>

                <div className="mt-2 text-muted">

                    {t("common.loading")}

                </div>

            </div>
        );
    }

    // =========================================================
    // RENDER
    // =========================================================

    return (

        <div
            className="div-width"
            style={{
                marginTop: "6rem"
            }}
        >

            {/* =================================================
                BREADCRUMB
            ================================================= */}

            <nav aria-label="breadcrumb">

                <ol className="breadcrumb mb-4">

                    <li className="breadcrumb-item">

                        <Link to="/">

                            <i className="fa-solid fa-house me-1"></i>

                            {t("menu.home")}

                        </Link>

                    </li>

                    <li className="breadcrumb-item">

                        <Link to="/listuserapp">

                            {t("utilisateur.titre")}

                        </Link>

                    </li>

                    <li className="breadcrumb-item active">

                        {t("utilisateur.edit")}

                    </li>

                </ol>

            </nav>

            {/* =================================================
                FORMULAIRE
            ================================================= */}

            <div className="border shadow rounded p-4">

                <div className="d-flex align-items-center mb-4">

                    <i className="fa-solid fa-user-pen fa-xl text-primary me-3"></i>

                    <h4 className="mb-0">

                        {t("utilisateur.edit")}

                    </h4>

                </div>

                <form onSubmit={onSubmit}>

                    <div className="row">

                        {/* =================================================
                            ID
                        ================================================= */}

                        <div className="col-md-6">

                            <div className="mb-3">

                                <label className="form-label">

                                    {t("common.id")}

                                </label>

                                <input
                                    type="text"
                                    className="form-control"
                                    value={
                                        data.id || ""
                                    }
                                    readOnly
                                />

                            </div>

                        </div>



                        {/* =================================================
                            NOM COMPLET
                        ================================================= */}

                        <div className="col-md-6">

                            <div className="mb-3">

                                <label className="form-label">

                                    {t("utilisateur.fullName")}

                                </label>

                                <input
                                    type="text"
                                    className={`form-control ${
                                        errorMessage.fullName
                                            ? "is-invalid"
                                            : ""
                                    }`}
                                    name="fullName"
                                    value={
                                        data.fullName ||
                                        ""
                                    }
                                    onChange={
                                        onInputChange
                                    }
                                />

                                {errorMessage.fullName && (

                                    <div className="invalid-feedback">

                                        {
                                            errorMessage.fullName
                                        }

                                    </div>

                                )}

                            </div>

                        </div>

                        {/* =================================================
                            EMAIL
                        ================================================= */}

                        <div className="col-md-6">

                            <div className="mb-3">

                                <label className="form-label">

                                    {t("utilisateur.email")}

                                </label>

                                <input
                                    type="email"
                                    className={`form-control ${
                                        errorMessage.email
                                            ? "is-invalid"
                                            : ""
                                    }`}
                                    name="email"
                                    value={
                                        data.email ||
                                        ""
                                    }
                                    onChange={
                                        onInputChange
                                    }
                                />

                                {errorMessage.email && (

                                    <div className="invalid-feedback">

                                        {
                                            errorMessage.email
                                        }

                                    </div>

                                )}

                            </div>

                        </div>

                        {/* =================================================
                            TELEPHONE
                        ================================================= */}

                        <div className="col-md-6">

                            <div className="mb-3">

                                <label className="form-label">

                                    {t(
                                        "utilisateur.phoneNumber"
                                    )}

                                </label>

                                <input
                                    type="tel"
                                    className="form-control"
                                    name="phoneNumber"
                                    value={
                                        data.phoneNumber ||
                                        ""
                                    }
                                    onChange={
                                        onInputChange
                                    }
                                />

                            </div>

                        </div>

                        {/* =================================================
                            TYPE
                        ================================================= */}

{/* =================================================
    TYPE UTILISATEUR
================================================= */}

<div className="col-md-6">

    <SingleSelectField
        label={t("utilisateur.type")}
        name="falahOrProf"
        value={data.falahOrProf || ""}
        options={[
            {
                id: "F",
                libelle: t("monProfile.farmer")
            },
            {
                id: "P",
                libelle: t("monProfile.professional")
            },
            {
                id: "S",
                libelle: t("monProfile.supplier")
            }
        ]}
        optionValue="id"
        optionLabel="libelle"
        onChange={onInputChange}
        error={errorMessage.falahOrProf}
        icon="bi-person-badge"
    />

</div>


{/* =================================================
    TYPE D'ACTIVITÉ
================================================= */}

<div className="col-md-6">

    {data.falahOrProf === "P" && (

        <SingleSelectField
            label={t("monProfile.activityType")}
            icon="bi-diagram-3"
            name="natureActivityType"
            value={
                data.natureActivityType || ""
            }
            onChange={onInputChange}
            error={
                errorMessage.natureActivityType
            }
            options={[
                {
                    id: "C",
                    libelle: t(
                        "consultant.types.agriculture"
                    )
                },
                {
                    id: "L",
                    libelle: t(
                        "consultant.types.livestock"
                    )
                }
            ]}
            optionValue="id"
            optionLabel="libelle"
        />

    )}

    {data.falahOrProf === "F" && (

        <SingleSelectField
            label={t("menu.activityProf")}
            icon="bi-person-badge"
            name="natureActivityType"
            value={
                data.natureActivityType || ""
            }
            onChange={onInputChange}
            error={
                errorMessage.natureActivityType
            }
            options={[
                {
                    id: "C",
                    libelle: t(
                        "monProfile.activityTypes.agriculture"
                    )
                },
                {
                    id: "L",
                    libelle: t(
                        "monProfile.activityTypes.livestock"
                    )
                },
                {
                    id: "M",
                    libelle: t(
                        "monProfile.activityTypes.mixed"
                    )
                }
            ]}
            optionValue="id"
            optionLabel="libelle"
        />

    )}

</div>

                        {/* =================================================
                            ACTIVATION
                        ================================================= */}

                        <div className="col-md-6">

                            <div className="form-check form-switch mb-3">

                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id="enabled"
                                    name="enabled"
                                    checked={
                                        data.enabled ??
                                        true
                                    }
                                    onChange={
                                        onInputChange
                                    }
                                />

                                <label
                                    className="form-check-label"
                                    htmlFor="enabled"
                                >

                                    {t(
                                        "utilisateur.enabled"
                                    )}

                                </label>

                            </div>

                        </div>

                    </div>

                    {/* =================================================
    ROLES
================================================= */}

<div className="col-md-12">

    <MultiSelectField

        label={t("utilisateur.roles")}

        options={roles}

        value={data.roles || []}

        optionValue="id"

        optionLabel={(role) =>
            role.name ||
            role.roleName ||
            ""
        }

        onAdd={onAddRole}

        onRemove={onRemoveRole}

        isDisabled={
            loadingRoles ||
            !data.email
        }

    />

</div>

                    {/* =================================================
                        BOUTONS
                    ================================================= */}

                    <div className="text-center mt-4">

                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={saving}
                        >

                            {saving ? (

                                <>
                                    <span
                                        className="spinner-border spinner-border-sm me-2"
                                        role="status"
                                    ></span>

                                    {t(
                                        "common.loading"
                                    )}
                                </>

                            ) : (

                                <>
                                    <i className="fa-solid fa-floppy-disk me-2"></i>

                                    {t("button.edit")}
                                </>

                            )}

                        </button>

                        <Link
                            to="/listuserapp"
                            className="btn btn-secondary mx-2"
                        >

                            <i className="fa-solid fa-xmark me-2"></i>

                            {t("button.cancel")}

                        </Link>

                    </div>

                </form>

            </div>

        </div>
    );
}